import React, { useCallback } from 'react'
import s from './UniverseButton.less'
import classNames from 'classnames'
import SVGIcon from '../svg/SVGIcon'
import { navigateTo } from '../../store/history/history.actions'
import { useAction } from '../utils/react-redux'

export default function UniverseButton(props) {
  const { url, text, active, link, route, routeOptions, onClick } = props

  const execNavigateTo = useAction(navigateTo)

  const onButtonClick = useCallback(
    e => {
      e.preventDefault()
      execNavigateTo({ route, routeOptions })
    },
    [execNavigateTo, route, routeOptions]
  )

  return (
    <a href={link} className={classNames(s.root, active && s.active)} onClick={onClick || (route && onButtonClick)}>
      <div className={s.button}>
        <SVGIcon url={url} />
      </div>
      <div className={s.text}>{text}</div>
    </a>
  )
}
